module.exports = new __parcel__URL__("images/all-person.d87a141a.png").toString();